import React, { useContext, useEffect, useState } from "react";
import firebase from "../../../../firebase/firebase";
import Button from "../../button/Button";
import { IToastContext, ToastContext } from "../../../../providers/Toast";
import { useTranslation } from "react-i18next";
import { slugify } from "../../../../utils/utils";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  bucket: string;
  folder: string;
  fileName?: string;
  onUploadComplete?: any;
}

const ImageFileUpload = ({ bucket, folder, fileName, onUploadComplete, ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [imageAsFile, setImageAsFile] = useState<any | null>(null);
  const [imageAsUrl, setImageAsUrl] = useState<string | null>("");

  const [isUploading, setIsUploading] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const handleImageAsFile = (e: any): void => {
    const image = e.target.files[0];
    setImageAsFile(image);
  };

  /**
   * Uploads file to firebase
   * @function
   *
   * @param e
   */
  const handleFireBaseUpload = (e: any) => {
    e.preventDefault();
    console.log("start of upload");
    // async magic goes here...
    if (!imageAsFile || imageAsFile === "") {
      console.error(`not an image, the image file is a ${typeof imageAsFile}`);
      return;
    }

    const name = fileName ? slugify(fileName) : imageAsFile.name;

    console.log(`${bucket}/${folder}/${name}`);

    const uploadTask = firebase
      .storage()
      .refFromURL(`${bucket}/${folder}/${name}`)
      .put(imageAsFile);

    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    uploadTask.on(
      "state_changed",
      (snapshot: any) => {
        setIsUploading(true);
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
        }
      },
      (error: any) => {
        // Handle unsuccessful uploads

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            break;

          case "storage/canceled":
            // User canceled the upload
            break;

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            break;
        }

        console.error(error);
        openToast({
          type: "error",
          title: "errors.general.title",
          callback: () => {},
        });
      },
      async () => {
        try {
          setImageAsFile(null);

          let originalDownloadURL = await uploadTask.snapshot.ref.getDownloadURL();
          setImageAsUrl(originalDownloadURL);

          // Wait for the extension thumbnail
          // FIXME: this is a workaround but firebase has not a better solution yet
          setTimeout(async () => {
            let thumbnailDownloadURL = await firebase
              .storage()
              .refFromURL(`${bucket}/${folder}/thumbnails/${name}_300x300`)
              .getDownloadURL();

            onUploadComplete(thumbnailDownloadURL);
            setIsUploading(false);
          }, 5000);
        } catch (err) {
          console.error(err);
          openToast({
            type: "error",
            title: "errors.general.title",
            callback: () => {},
          });
        }
      }
    );

    // Pause the upload
    // uploadTask.pause();

    // // Resume the upload
    // uploadTask.resume();

    // // Cancel the upload
    // uploadTask.cancel();
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // console.log("[CustomInputText] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // console.log("[CustomInputText] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className="file-upload">
      <input
        accept="image/*"
        type="file"
        name="file"
        id="file"
        className="input-file"
        onChange={handleImageAsFile}
      />
      <label htmlFor="file">
        {!isUploading && !imageAsFile && t("forms.choose_file_image")}
        {!isUploading && !!imageAsFile && imageAsFile.name}
        {!!isUploading && t("forms.uploading_image")}
      </label>
      <Button
        className={"btn btn-primary"}
        onClick={handleFireBaseUpload}
        disabled={!imageAsFile || !!isUploading}
        loading={!!isUploading}
      >
        {t("forms.upload_file")}
      </Button>
    </div>
  );
};
export default ImageFileUpload;
